import initVueApp from "@/core.js";
const component = require(`./../views/Loyalty2023.vue`).default;
initVueApp(component);
